import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage, Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {RendererOf} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import noResults from '../../../../assets/images/noResults.png';
import {AnalyticsInfoState} from '../../reportElements/analyticsInfoState';

/*
 * Props.
 */

interface LiveDashboardAssignedByTeammateEmptyStateProps {
  renderTeammatesDropdown: RendererOf<PopoverTransferProps>;
}

/*
 * Styles.
 */

const StyledAnalyticsInfoState = styled(AnalyticsInfoState)`
  margin: auto;
`;

const StyledBodyDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

/*
 * Component.
 */

export const LiveDashboardAssignedByTeammateEmptyState: FC<
  LiveDashboardAssignedByTeammateEmptyStateProps
> = ({renderTeammatesDropdown}) => {
  const localize = useLocalize();
  const title = localize(
    defineMessage({
      id: 'live-dashboard-assigned-by-teammate-empty-state',
      message: 'No teammates yet',
    }),
  );

  return (
    <StyledAnalyticsInfoState
      imgWidth={92}
      imgHeight={67}
      imgPath={noResults}
      title={title}
      body={
        <StyledBodyDiv>
          <Trans id="live-dashboard-assigned-by-teammate-empty-state-content">
            Add teammates to see their current workload and availability status.
          </Trans>
          <PopoverCoordinator
            renderButton={() => (
              <Button variant={ButtonVariantsEnum.PRIMARY}>
                <Trans id="live-dashboard-assigned-by-teammate-add-teammates">Add teammates</Trans>
              </Button>
            )}
            renderModal={renderTeammatesDropdown}
          />
        </StyledBodyDiv>
      }
    />
  );
};
